/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useRef } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../../../../../../app/dialog/dialog.actions';
import { deleteTaskSimple } from '../../../../../../../../app/page/page-storage/tasks-simple/tasks-simple.actions';
import {
  clearTaskModalStatuses,
  storeTaskModalStatus,
} from '../../../../../../../../app/task-modals/task-modals.actions';
import { taskModalSelectors } from '../../../../../../../../app/task-modals/task-modals.selectors';
import useOutsideClick from '../../../../../../../../utils/click.utils';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';

import { IDeleteTaskProps } from './types';

export const DeleteTask: FunctionComponent<IDeleteTaskProps> = ({ task }) => {
  const dispatch = useDispatch();
  const triggerRef = useRef<HTMLAnchorElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);

  const open = useSelectWithParams(taskModalSelectors.selectTaskModalStatus, 'taskDelete');

  const toggle = useCallback(() => {
    if (open) {
      dispatch(clearTaskModalStatuses());
    } else {
      dispatch(storeTaskModalStatus('taskDelete'));
    }
  }, [dispatch, open]);

  const onDeleteTask = useCallback(() => {
    dispatch(deleteTaskSimple(task.id));
    dispatch(closeDialog('trelloReplacementFormDialog'));
    dispatch(clearTaskModalStatuses());
  }, [dispatch, task.id]);

  const handleClickOutside = () => {
    if (open) {
      dispatch(clearTaskModalStatuses());
    }
  };

  useOutsideClick({
    callback: handleClickOutside,
    refs: [popupRef, triggerRef],
    enabled: open,
  });
  return (
    <div className={open ? 'dropdown opened' : 'dropdown'}>
      <a
        className="btn w100 gray-bg darkGray px-1 f-1 ml-0 mb-1 mt-1 dropdown-button"
        title="Delete"
        onClick={toggle}
        ref={triggerRef}
      >
        <i className="icon f-9 blueGray icon-upload mr-1" /> Delete
      </a>
      <div className="dropdown-menu drop-right drop-up max-h320">
        <div className="mini-popup" ref={popupRef}>
          <div className="mini-popup-header">
            Delete card
            <span className="close_mini_popup" onClick={toggle}>
              ×
            </span>
          </div>
          <div className="mini-popup-body">
            <p className="ln mb-2 darkGray">Deleting a card is permanent and there is no way to get it back.</p>
            <a className="btn btn-md red-bg white d-block w100 jcc" onClick={onDeleteTask}>
              Delete card
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
